export const CssVariables = {
  maxWidth: "--da-max-width",
  mobilePadding: "--da-mobile-padding",
  desktopPadding: "--da-desktop-padding"
};
export const BREAKPOINT = 1024;
export const TAB_BREAKPOINT = 768;
export const LG_BREAKPOINT = 1440;
export const XL_BREAKPOINT = 1920;
export const MediaQuery = {
  xl: `@media (min-width: ${XL_BREAKPOINT}px)`,
  lg: `@media (min-width: ${LG_BREAKPOINT}px)`,
  desktop: `@media (min-width: ${BREAKPOINT}px)`,
  tablet: `@media (min-width:${TAB_BREAKPOINT}px)`,
  mobile: `@media (max-width:${BREAKPOINT - 1}px)`,
  portraitMD: `@media (orientation:portrait) and (min-width: ${BREAKPOINT}px)`
};
